/* ============================================================
   src/debugLog.ts
   ============================================================
   Production console noise, gated.

   Startup traces, per-leg settings fetches and the cloud-draft
   chatter are genuinely useful when something misbehaves in the
   field — and useless the rest of the time. Several of them also
   printed customer name and email into the console of a machine
   that is not always ours (a customer looking over a shoulder, a
   screen share).

   So: routed through here, silent in a production build unless the
   user opts in for this device by setting

       localStorage.setItem("du_debug", "1")

   and reloading. Development builds always log, so nothing changes
   while working locally.

   console.error and console.warn are deliberately NOT routed
   through this — a real failure should always be visible.
   ============================================================ */

function debugEnabled(): boolean {
  if (process.env.NODE_ENV !== "production") return true;
  try {
    return (
      typeof localStorage !== "undefined" &&
      localStorage.getItem("du_debug") === "1"
    );
  } catch {
    // Private mode / blocked storage — stay quiet rather than throw.
    return false;
  }
}

/** Gated stand-in for console.log. Same signature, no output in a
 *  production build unless du_debug is set on this device. */
export function dlog(...args: any[]): void {
  if (!debugEnabled()) return;
  // eslint-disable-next-line no-console
  console.log(...args);
}
